import Big from "big.js";
import { MoneyConstants } from "./moneyConstants";

export class FSMoneyFactory {
  static toMoney(val) {
    if (val === undefined || val === null) {
      val = 0;
    }

    Big.DP = MoneyConstants.CALCULATE_DECIMAL_PLACES_CENTS;
    Big.RM = MoneyConstants.ROUNDING_METHOD;
    return new Big(val);
  }
}
